import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { api, digits, errMsg, maskDoc, maskPhone } from "@/lib/api";
import { validDoc } from "@/lib/document";
import { checkBasic } from "@/lib/boyCourier";
import { NextBtn, StepHead } from "./StepBar";

const cpfMask = (v) => maskDoc(digits(v).slice(0, 11));

export function StepBasic({ f, patch, code, onNext }) {
  const [busy, setBusy] = useState(false);
  const cpfBad = digits(f.cpf).length === 11 && !validDoc(digits(f.cpf));
  const go = async (e) => {
    e.preventDefault();
    const m = checkBasic(f);
    if (m) return toast.error(m);
    setBusy(true);
    try {
      const { data } = await api.get(`/public/boy/${code}/couriers/check/${digits(f.cpf)}`);
      if (data.exists) return toast.error("Já existe um cadastro com este CPF nesta empresa. Aguarde o retorno pelo WhatsApp.");
      onNext();
    } catch (x) {
      toast.error(errMsg(x));
    } finally {
      setBusy(false);
    }
  };
  const inp = (k, mask) => (e) => patch({ [k]: mask ? mask(e.target.value) : e.target.value });
  return (
    <form onSubmit={go} className="space-y-4" data-testid="boy-step-basic">
      <StepHead title="Olá! Vamos começar o seu cadastro?" text="Para criar sua conta de entregador, precisamos de alguns dados iniciais." />
      <Field label="CPF" hint={cpfBad && <span className="text-red-500" data-testid="boy-courier-cpf-error">CPF inválido</span>}>
        <Input value={f.cpf} onChange={inp("cpf", cpfMask)} inputMode="numeric" placeholder="000.000.000-00" className={cpfBad ? "h-12 border-red-500" : "h-12"} data-testid="boy-courier-cpf-input" />
      </Field>
      <Field label="Nome completo (igual ao documento)">
        <Input value={f.name} onChange={inp("name")} autoComplete="name" className="h-12" data-testid="boy-courier-name-input" />
      </Field>
      <Field label="Celular com DDD" hint="É por ele que chegam as corridas no WhatsApp">
        <Input value={f.phone} onChange={inp("phone", maskPhone)} inputMode="tel" autoComplete="tel" placeholder="(00) 00000-0000" className="h-12" data-testid="boy-courier-phone-input" />
      </Field>
      <Field label="E-mail">
        <Input type="email" value={f.email} onChange={inp("email")} autoComplete="email" placeholder="voce@email.com" className="h-12" data-testid="boy-courier-email-input" />
      </Field>
      <NextBtn busy={busy} testid="boy-step-basic-next">Continuar</NextBtn>
    </form>
  );
}
